import { render, staticRenderFns } from "./activeDetails.vue?vue&type=template&id=ca529944&scoped=true&"
import script from "./activeDetails.vue?vue&type=script&lang=js&"
export * from "./activeDetails.vue?vue&type=script&lang=js&"
import style0 from "./activeDetails.vue?vue&type=style&index=0&id=ca529944&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca529944",
  null
  
)

export default component.exports